import React from 'react';
import PropTypes from 'prop-types';

import { Tags } from 'Components/molecules/Tags';

/**
 * @name getTags
 * @param tags
 * @param checkTagsCondition
 * @param extraClassNames
 * @returns {JSX.Element|boolean}
 */
export const getTags = ({
  checkTagsCondition = true,
  extraClassNames = {},
  tags = null,
}) => {
  if (checkTagsCondition && (tags === null || (Array.isArray(tags) && tags.length === 0))) {
    return false;
  }

  return (
    <Tags
      content={tags}
      extraClassNames={extraClassNames}
    />
  );
};

getTags.propTypes = {
  checkTagsCondition: PropTypes.bool,
  extraClassNames: PropTypes.shape(),
  tags: PropTypes.arrayOf(PropTypes.string),
};

getTags.defaultProps = {
  checkTagsCondition: true,
  extraClassNames: {},
  tags: null,
};
